import { render, staticRenderFns } from "./PlacementExamPartClassroomsTable.vue?vue&type=template&id=81277980&"
import script from "./PlacementExamPartClassroomsTable.vue?vue&type=script&lang=js&"
export * from "./PlacementExamPartClassroomsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports